module.exports = __webpack_public_path__ + "static/media/thrift-banner.a036b339.jpg";